import React from 'react';

import { GenericMessageDescriptor } from '@main/core-ui';

/**
 * Size variants for steps
 */
export enum StepSize {
  Small = 'small',
  Default = 'default',
}

/**
 * Step status types
 */
export enum StepStatus {
  Wait = 'wait',
  Process = 'process',
  Finish = 'finish',
  Error = 'error',
}

/**
 * Props for Step component
 */
export interface StepProps {
  /**
   * Title of the step
   */
  title?: GenericMessageDescriptor;
  /**
   * Description of the step
   */
  description?: GenericMessageDescriptor;
  /**
   * Custom icon for the step
   */
  icon?: React.ReactNode;
  /**
   * Status of the step
   */
  status?: StepStatus;
  /**
   * Additional CSS styles
   */
  style?: React.CSSProperties;
  /**
   * Size of the step indicator
   */
  size?: StepSize;
}

/**
 * Props for Steps component
 */
export interface StepsProps {
  /**
   * The current step
   */
  current?: number;
  /**
   * Whether the steps should be displayed horizontally
   */
  isHorizontal?: boolean;
  /**
   * Status of the current step
   */
  status?: StepStatus;
  /**
   * Size of the steps
   */
  size?: StepSize;
  /**
   * Child elements
   */
  children?: React.ReactNode;
}

/**
 * Context type for Steps component
 */
export interface StepsContextType {
  /**
   * Index of the current active step
   */
  currentIndex: number;
  /**
   * Global status to apply to the current step
   */
  globalStatus: StepStatus;
  /**
   * Size variant for steps
   */
  size: StepSize;
}
